// extracted by mini-css-extract-plugin
export default {"containerModalGeneric":"ModalGeneric_containerModalGeneric__6t4wb","title":"ModalGeneric_title__6ANCv"};